// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"0b8f0e9e","259":"ece5bf5d","453":"12d06f72","809":"8ed5e732"}[chunkId] + ".chunk.js";
};